import { useCallback, useState } from 'react';

export const useToggle = (initialValue = false) => {
	const [isOn, setIsOn] = useState(initialValue);

	const toggle = useCallback(() => setIsOn((isCurrentlyOn) => !isCurrentlyOn), []);

	return [isOn, toggle] as const;
};
